import { z } from 'zod';

export const ALERT_CATEGORY_VALUES = [
  'calculation',
  'compliance',
  'payment',
  'deadline',
  'all',
] as const;

export type PayrollAlertCategoryFilter = (typeof ALERT_CATEGORY_VALUES)[number];

export const AlertSearchSchema = z.object({
  category: z.enum(ALERT_CATEGORY_VALUES).default('calculation'),
  freeText: z.string().optional(),
  severity: z.enum(['all', 'info', 'warning', 'critical']).default('all'),
  resolved: z.enum(['all', 'resolved', 'unresolved']).default('unresolved'),
  pageIndex: z.coerce.number().default(0),
  pageSize: z.coerce.number().default(100),
});

export type AlertSearchParams = z.infer<typeof AlertSearchSchema>;
